import Skeleton from '@material-ui/lab/Skeleton/Skeleton';
import classNames from 'clsx';
import React from 'react';

import styles from './Score.scss';

export enum Team {
  HOME = 'HOME',
  AWAY = 'AWAY'
}

interface Props {
  team: Team;
  score?: string;
  /**
   * some sports scoreboard might contain more than 1 digit score
   * @example Scores for tennis could contain 2 digits scores
   */
  defaultNumberOfDigits?: 1 | 2;
  isTransparentBg?: boolean;
  isLoading?: boolean;
  isValidInPlayStatus?: boolean;
  isTieBreak?: boolean;
  isPenaltyShootout?: boolean;
}

const Score: React.FC<Props> = ({
  team,
  score,
  defaultNumberOfDigits = 1,
  isLoading,
  isTransparentBg,
  isValidInPlayStatus,
  isTieBreak,
  isPenaltyShootout,
  ...props
}) => (
  <span
    className={classNames(styles.score, {
      [styles.loading]: isLoading,
      [styles.twoDigits]: defaultNumberOfDigits === 2
    })}
  >
    {isLoading ? (
      <Skeleton
        variant="rect"
        height="var(--score-loading-height)"
        width="var(--score-loading-width)"
        animation="pulse"
        className={classNames({
          [styles.awayScoreSkeleton]: team === Team.AWAY,
          [styles.homeScoreSkeleton]: team === Team.HOME
        })}
      />
    ) : (
      <span
        data-testid={`scoreboard-${team.toLowerCase()}-score`}
        className={classNames({
          [styles.homeScore]: team === Team.HOME,
          [styles.awayScore]: team === Team.AWAY,
          [styles.transparentBackground]: isTransparentBg,
          [styles.inPlay]: isValidInPlayStatus,
          [styles.tieBreak]: isTieBreak,
          [styles.penaltyShootout]: isPenaltyShootout
        })}
      >
        {score ?? '-'}
      </span>
    )}
  </span>
);

export default Score;
